import { render, staticRenderFns } from "./AdminUserManager.vue?vue&type=template&id=c483067a&scoped=true&"
import script from "./AdminUserManager.vue?vue&type=script&lang=js&"
export * from "./AdminUserManager.vue?vue&type=script&lang=js&"
import style0 from "./AdminUserManager.vue?vue&type=style&index=0&id=c483067a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c483067a",
  null
  
)

export default component.exports